
import { Enums } from '@bode-canada/core';
import ExternalLink from '@/ui-kit/components/external-link';
import Button from '@/ui-kit/components/button';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { LISTING_TRACK_EVENT_ORIGIN_TYPES } from '@/constants';
import { AUTHENTICATE, getAction } from '@/store/user/actions';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import ExternalNavigationHelper from '@/utils/external-navigation';
import PropertyPathHelper from '@/utils/PropertyPathHelper';

const SINGLE_TRANSACTION_AMOUNT = 1;

export default {
  name: 'ListingTransactionTip',
  components: {
    Button,
    Typography,
    ExternalLink,
  },
  props: {
    iconSource: {
      default: '',
      type: String,
    },
    transaction: {
      required: true,
      type: Object,
    },
    transactionsAmount: {
      default: SINGLE_TRANSACTION_AMOUNT,
      type: Number,
    },
    id: {
      required: true,
      type: Number,
    },
    origin: {
      default: null,
      type: String,
    },
    addressId: {
      default: 0,
      type: Number,
    },
    isLinkVisible: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StyleFontWeightType,
      TypographyType,
      ButtonFillType,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userData;
    },
    isAuthenticatedUser() {
      return this.user.isAuthenticated;
    },
    soldDataUrl() {
      return PropertyPathHelper.generateSoldRouteFromListing(this.transaction);
    },
    titlePrefix() {
      return this.transactionsAmount > SINGLE_TRANSACTION_AMOUNT ? 'Last sold for' : 'This home sold for';
    },
  },
  methods: {
    async handleAuthenticateClick() {
      await this.$store.dispatch(getAction(AUTHENTICATE));

      if (this.user.isAuthenticated) {
        ExternalNavigationHelper.openInNewWindow(this.soldDataUrl);
      }
    },
    handleTransactionClick() {
      this.trackEvent(ListingPageEvent.SoldDataLink);
    },
    trackEvent(eventType) {
      const trackOrigin = this.origin === Enums.ListingOriginEnum.BODE
        ? LISTING_TRACK_EVENT_ORIGIN_TYPES.Bode
        : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;

      this.$track(`${trackOrigin}_${eventType}`,
        {
          listingId: this.id,
          listingType: this.origin,
        });
    },
  },
};
